import ZAFClient from 'zendesk_app_framework_sdk';

// Instantiate a single ZAFClient instance.
// ZAFClient.init must only be called once; otherwise, it will lead to redundant requests.

const client = ZAFClient.init();
export default client;
